module.exports = __webpack_public_path__ + "static/media/arrow-icon.cc339a7b.svg";